

// Lazy-loaded components for code splitting
const GroupPermissionsList = () => import(/* webpackChunkName: "group-permissions" */ "./pages/ListPage.vue");
const GroupPermissionsDetail = () => import(/* webpackChunkName: "group-permissions" */ "./pages/FormPage.vue");
const GroupPermissionsIndex = () => import(/* webpackChunkName: "group-permissions" */ "./pages/IndexPage.vue");
const Report = () => import(/* webpackChunkName: "group-permissions" */ "./pages/Report.vue");
export default [
    {
        path: "/group_permissions",
        component: GroupPermissionsIndex,
        redirect: "/group_permissions/list",
        name: "group_permissions",
        children: [
            {
                path: "list",
                component: GroupPermissionsList,
                name: "group_permissions.list",
            },
            {
                path: "create",
                component: GroupPermissionsDetail,
                name: "group_permissions.create",
                props: { create: true },
            },
            {
                path: "edit/:id",
                component: GroupPermissionsDetail,
                name: "group_permissions.edit",
                props: { create: false },
            },
            {
                path: "report",
                component: Report,
                name: "group_permissions.report",
            },
        ],
    },
];
